import { api, getHeaders } from '@/api';
import { queryOptions } from '@tanstack/react-query';

import { whoAmISchema, type WhoAmIResponse } from './schema';

const authEndpoints = {
  getWhoAmI: async (): Promise<WhoAmIResponse | null> => {
    try {
      const { data } = await api.get<WhoAmIResponse>('api/site/whoami', getHeaders());

      // Non-throwing schema check: surface backend contract drift as a warning
      // without ever nulling the user or throwing. A parse miss must NOT break auth.
      const result = whoAmISchema.safeParse(data);
      if (!result.success) {
        console.warn('whoami schema drift:', result.error);
      }

      return data;
    } catch (error) {
      console.error('Error fetching whoAmI:', error);
      return null;
    }
  }
};

export const authQueries = {
  all: () => ['auth'] as const,
  whoAmI: () =>
    queryOptions({
      queryKey: [...authQueries.all(), 'whoami'],
      queryFn: () => authEndpoints.getWhoAmI()
    })
};

export { authEndpoints };
